/**
 * Date-of-birth input helpers for the member-portal login.
 *
 * `isoDobOrNull` rejects impossible dates rather than letting `new Date(...)`
 * roll them over before an identity-match request.
 */

/**
 * Return a complete `YYYY-MM-DD` value, or `null` for an incomplete or
 * impossible date. Range-checks the parts and round-trips through `Date` so
 * rollover inputs reject instead of silently becoming a valid-but-wrong date.
 */
export function isoDobOrNull(value: string): string | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value.trim());
  if (!m) return null;
  const year = Number(m[1]);
  const month = Number(m[2]);
  const day = Number(m[3]);
  if (month < 1 || month > 12) return null;
  if (day < 1 || day > 31) return null;
  if (year < 1900) return null;
  // Round-trip check: a rolled-over date (Feb 30 becomes Mar 2) won't match the
  // parsed components. UTC keeps any timezone from shifting the calendar day.
  const d = new Date(Date.UTC(year, month - 1, day));
  if (d.getUTCFullYear() !== year || d.getUTCMonth() !== month - 1 || d.getUTCDate() !== day) {
    return null;
  }
  return value;
}
